/**
 * @flow
 */

import Button from './Button'
import styled from 'styled-components'
import { withTenant } from '../../context/tenantConfig'

const RoundButton = styled(Button)`
  display: flex;
  display: inline-block;
  justify-content: center;
  align-items: center;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-right: 5px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 0px;
  background: ${props => props.tenant.config.theme.background};

  i {
    transition: all 0.4s ease;
  }

  &:disabled {
    &:hover {
      background: ${props => props.tenant.config.theme.background};
      border-color: #444;
      color: #444;
      cursor: default;
    }
  }

  &:hover {
    color: ${props => props.tenant.config.theme.background};

    i {
      color: ${props => props.tenant.config.theme.background};
    }
  }

  &:focus {
    outline-color: ${props => props.tenant.config.theme.primary};
    border-color: ${props => props.tenant.config.theme.primary};
  }
`

export default withTenant(RoundButton)
